import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, HelpBlock, Glyphicon, Col, Row } from 'react-bootstrap';
import { Redirect, Prompt } from 'react-router-dom';
import { EditState } from '../shared/enums';
import { ModalOKCancel } from '../shared/modals';
import { PageHeader, PageHeaderRight } from '../shared/PageHeader';
import { BsValidation } from '../shared/bsHelper';
import { toast } from 'react-toastify';
import { UserRoles } from '../shared/enums';

class Users extends Component {
    displayName = Users.name;

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            isLoading: true,
            errorCode: 0,
            errorMessage: '',
            isEditing: false, // todo - replace usage with EditState
            editState: 'List',
            editFormData: {
                id: '',
                userName: '',
                email: '',
                roleId: 'select',
                roleName: '',
                phoneNumber: '',
                storeId: 'select',
                store: '',
                orderGuideGroupId: 'select',
                orderGuideGroupName: '',
                name: ''
            },
            lookupStores: [],
            lookupOrderGuideGroups: [],
            lookupRoles: [],
            selectedRoleName: '',
            showDeleteModal: false,
            showClientLookup: false,
            errorResult: undefined,
            isDirty: false
        };
    }

    async componentWillMount() {
        if (this.state.errorResult !== undefined)
            console.log('Error result:' + this.state.errorResult);

        const url = `/api/users`;
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        this.setState({ isLoading: true });

        const response = await fetch(url, fetchConfig);
        if (response.ok) {
            try {
                let userListVM = await response.json();
                //console.log(userListVM);
                this.setState({
                    ...this.state,
                    users: userListVM.userViewModels,
                    lookupStores: userListVM.lookupStores,
                    lookupRoles: userListVM.lookupRoles,
                    lookupOrderGuideGroups: userListVM.lookupOrderGuideGroups,
                    isLoading: false
                });
                //setTimeout(() => {
                //    console.log(this.state);
                //}, 100);
            } catch (e) {
                //console.log('Error parsing json response: ' + e);
                this.setState({ errorCode: 999, errorMessage: 'Error parsing Json', isLoading: false });
                // todo handle 
            }
        } else {
            // todo handle 500s, 401s, etc.
            this.setState({ errorCode: response.status, isLoading: false });
        }

    }

    addClicked = (e) => {
        e.preventDefault();
        this.setState({
            editFormData: {
                id: '',
                userName: '',
                email: '',
                roleId: '',
                roleName: '',
                phoneNumber: '',
                storeId: '',
                storeName: '',
                orderGuideGroupId: '',
                orderGuideGroupName: '',
                name: ''
            },
            isEditing: true,
            editState: EditState.Add
        });
    }

    editClicked = (id, e) => {
        e.preventDefault();
        var user = this.state.users.find((user) => {
            return user.id === id;
        });
        this.setState({ editFormData: { ...this.state.editFormData, ...user }, isEditing: true, editState: EditState.Edit });
    }

    handleFormControlChange = (e) => {
        this.setState({ editFormData: { ...this.state.editFormData, [e.target.name]: e.target.value }, isDirty: true });
    }

    sendPasswordReset = async (e) => {
        e.preventDefault();

        const data = {
            'email': this.state.editFormData.email,
            'userName': this.state.editFormData.userName
        };

        toast.warn("Processing reset request...", { autoClose: 50000, hideProgressBar: false });
        let response = await fetch("/api/login/requestpasswordreset", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            let errorResult = await response.json();
            this.setState({ ...this.state, errorResult: errorResult, submitEnabled: true });
            if (errorResult.errorSummary) {
                toast.error(errorResult.errorSummary);
                if (errorResult.errors.length > 0) {
                    for (let err of errorResult.errors) {
                        console.log(err.errorMessage);
                    }
                }
            }
        }
        toast.dismiss();
    }

    onSaveSubmit = async (e) => {
        e.preventDefault();
        //console.log(this.state.editFormData);

        // Clear errors
        this.clearValidationState();

        this.setState({ isLoading: true });

        // Edit or Save
        let url = `/api/users/save`;
        let method = 'PUT';
        if (this.state.editState === EditState.Add) {
            url = `/api/users/add`;
            method = 'POST';
        }

        let saveJson = JSON.stringify(this.state.editFormData);
        //console.log(saveJson);

        const fetchConfig = {
            method: method,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: saveJson
        };
        const response = await fetch(url, fetchConfig);
        if (response.ok) {
            try {
                let returnedUser = await response.json();

                let msg = "User Saved";
                if (this.state.editState === EditState.Add) {
                    msg = `Created User ${this.state.editFormData.userName}.`;
                }
                toast.success(msg);

                if (!returnedUser.isInGroup && returnedUser.roleName === UserRoles.SalesRep) {
                    toast.warn("User does not belong to the selected default Order Guide Group.");
                }

                if (!returnedUser.orderGuideGroupId && returnedUser.roleName === UserRoles.StoreBuyer) {
                    toast.warn("User will not be able to log in until Store is assigned to an Order Guide Group.");
                }

                // clone users array
                let clonedUsers = [...this.state.users];

                if (this.state.editState === EditState.Edit) {
                    // find the index of the user object that was returned
                    let idx = this.state.users.findIndex((user) => {
                        return user.id === returnedUser.id;
                    });

                    // update the cloned array with the returned user
                    clonedUsers[idx] = returnedUser;

                } else { // add, append new user
                    clonedUsers = [...clonedUsers, returnedUser];
                }

                // update the entire users array with cloned array
                this.setState({ users: clonedUsers, isEditing: false, isLoading: false, editState: EditState.List });
            } catch (e) {
                console.log('Error saving user: ' + e);
            }
        }
        else {
            let errorResult = await response.json();
            this.setState({ errorResult: errorResult, isLoading: false });
            toast.warn(this.state.errorResult.errorSummary || "Invalid data.");
        }
    }

    onRoleSelected = (e) => {
        e.preventDefault();
        const roleId = this.selectedRoleElem.value;
        var foundRole = this.state.lookupRoles.find((role) => {
            return role.id === roleId;
        });
        const roleName = foundRole ? foundRole.name : '';
        this.setState({ editFormData: { ...this.state.editFormData, roleId: roleId, roleName: roleName }, isDirty: true });
    }
    onStoreSelected = (e) => {
        e.preventDefault();
        //const storeId = this.selectedStoreElem.value;
        //var foundStore = this.state.lookupStores.find((store) => {
        //    return store.storeId === storeId;
        //});

        this.setState({ editFormData: { ...this.state.editFormData, storeId: this.selectedStoreElem.value }, isDirty: true });
    }

    onOrderGuideGroupSelected = (e) => {
        e.preventDefault();
        //const orderGuideGroupId = this.selectedOrderGuideGroupElem.value;
        //var foundOrderGuideGroup = this.state.lookupOrderGuideGroups.find((ogg) => {
        //    return ogg.orderGuideGroupId === orderGuideGroupId;
        //});

        this.setState({ editFormData: { ...this.state.editFormData, orderGuideGroupId: this.selectedOrderGuideGroupElem.value }, isDirty: true });
    }

    onCancelClicked = (e) => {
        //console.log(this.state);
        this.setState({ ...this.state, isEditing: false, editState: EditState.List, errorResult: undefined, isLoading: false });
        //console.log("after set state in cancel");
    }

    onDeleteClicked = (e) => {
        this.setState({ showDeleteModal: true });
    }
    onDeleteModalCancel = (e) => {
        this.setState({ showDeleteModal: false });
    }
    async onDeleteModalOK(e) {
        this.setState({ showDeleteModal: false });

        const userId = this.state.editFormData.id;
        const url = `/api/users/delete/${userId}`;
        const fetchConfig = {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        const response = await fetch(url, fetchConfig);

        if (response.ok) {
            const cleanedUsers = this.state.users.filter((user) => {
                return user.id !== userId;
            });

            this.setState({
                users: cleanedUsers,
                isEditing: false,
                editState: EditState.List
            });
        } else {
            // todo
        }

        // setTimeout(() => { alert('todo - Delete'); }, 200);
    }

    clearValidationState = () => {
        try {
            // Apparently Edge doesn't create Symbol.iterator for node lists
            // so we cannot use for-let-of, and instead must convert nodelist to an array
            let hasErrors = document.getElementsByClassName('has-error');
            if (hasErrors && hasErrors.length > 0) {
                let arrayOfErrors = Array.from(hasErrors);
                for (let i = 0; i < arrayOfErrors.length; i++) {
                    arrayOfErrors[i].classList.remove('has-error');
                }
            }
            let helpBlocks = document.getElementsByClassName('help-block');
            if (helpBlocks && helpBlocks.length > 0) {
                let arrayOfHelpBlocks = Array.from(helpBlocks);
                for (let i = 0; i < arrayOfHelpBlocks.length; i++) {
                    arrayOfHelpBlocks[i].textContent = '';
                }
            }
        }
        catch (error) {
            console.log('Error clearing validations'); console.log(error);
        }

        toast.dismiss();
        this.setState({ errorResult: undefined });
    }

    renderListGrid = () => {
        if (this.state.isLoading) {
            return <p style={{ padding: '10px' }}><em>Loading...</em></p>;
        }

        return (
            <div className="scrollContainer">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>User Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Store</th>
                            <th>Order Guide</th>
                            <th>Role</th>
                            <th>Edit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.users.map(user =>
                            (<tr key={user.id}>
                                <td>{user.userName}</td>
                                <td>{user.email}</td>
                                <td>{user.phoneNumber}</td>
                                <td>{user.storeName}</td>
                                <td>{user.orderGuideGroupName}</td>
                                <td>{user.roleName}</td>
                                <td>
                                    <button
                                        className="btn btn-outline-danger btn-sm deleteButton"
                                        onClick={this.editClicked.bind(this, user.id)}
                                        style={{ padding: '7px 10px' }}
                                    >
                                        <Glyphicon glyph="edit" />
                                    </button>
                                </td>
                            </tr>)
                        )}
                    </tbody>
                </table>
            </div>
        );
    }

    renderEditForm = () => {
        return (
            <Col sm={12}>
                <form onSubmit={this.onSaveSubmit.bind(this)} >
                    <Row>
                        <Col sm={6}>
                            <FormGroup controlId="userName" validationState={BsValidation.getFieldValidationState("userName", this.state.errorResult)}>
                                <ControlLabel>User Name*</ControlLabel>
                                <FormControl placeholder="Unique, no spaces" componentClass="input" type="text" value={this.state.editFormData.userName || ''} name="userName" onChange={this.handleFormControlChange.bind(this)} />
                                <HelpBlock>{BsValidation.getFieldValidationText("userName", this.state.errorResult)}</HelpBlock>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup controlId="name">
                                <ControlLabel>Display Name</ControlLabel>
                                <FormControl placeholder="Display Name" componentClass="input" type="text" value={this.state.editFormData.name || ''} name="name" onChange={this.handleFormControlChange.bind(this)} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup controlId="email" validationState={BsValidation.getFieldValidationState("email", this.state.errorResult)}>
                                <ControlLabel>Email*</ControlLabel>
                                <FormControl componentClass="input" type="email" value={this.state.editFormData.email || ''} name="email" onChange={this.handleFormControlChange.bind(this)} />
                                <HelpBlock>{BsValidation.getFieldValidationText("email", this.state.errorResult)}</HelpBlock>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup controlId="phoneNumber" validationState={BsValidation.getFieldValidationState("phoneNumber", this.state.errorResult)}>
                                <ControlLabel>Phone Number</ControlLabel>
                                <FormControl componentClass="input" type="tel" placeholder="123-123-1234" value={this.state.editFormData.phoneNumber || ''} name="phoneNumber" onChange={this.handleFormControlChange.bind(this)} />
                                <HelpBlock>{BsValidation.getFieldValidationText("phoneNumber", this.state.errorResult)}</HelpBlock>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup controlId="roleId" validationState={BsValidation.getFieldValidationState("roleId", this.state.errorResult)}>
                                <ControlLabel>Role*</ControlLabel>
                                <FormControl componentClass="select" value={this.state.editFormData.roleId || 'select'} name="roleId"
                                    onChange={this.onRoleSelected.bind(this)}
                                    inputRef={el => this.selectedRoleElem = el}
                                    placeholder="Select Role"
                                >
                                    <option key={'select'} value="select">--Select--</option>
                                    {this.state.lookupRoles.map((role) =>
                                        <option key={role.id} value={role.id}>{role.name}</option>
                                    )}
                                </FormControl>
                                <HelpBlock>{BsValidation.getFieldValidationText("roleId", this.state.errorResult)}</HelpBlock>
                            </FormGroup>
                        </Col>
                        {this.state.editFormData.roleName === 'StoreBuyer' &&
                            <Col sm={6}>
                                <FormGroup controlId="storeId" validationState={BsValidation.getFieldValidationState("storeId", this.state.errorResult)}>
                                    <ControlLabel>Store*</ControlLabel>
                                    <FormControl componentClass="select" value={this.state.editFormData.storeId || 'select'} name="storeId"
                                        onChange={this.onStoreSelected.bind(this)}
                                        inputRef={el => this.selectedStoreElem = el}
                                        placeholder="Select Store"
                                    >
                                        <option key={'select'} value="">--Select--</option>
                                        {this.state.lookupStores.map((store) =>
                                            <option key={store.storeId} value={store.storeId}>{store.customer_Name}</option>
                                        )}
                                    </FormControl>
                                    <HelpBlock>{BsValidation.getFieldValidationText("storeId", this.state.errorResult)}</HelpBlock>
                                </FormGroup>
                            </Col>
                        }
                        {this.state.editFormData.roleName !== 'StoreBuyer' &&
                            <Col sm={6}>
                                <FormGroup controlId="orderGuideGroupId" validationState={BsValidation.getFieldValidationState("orderGuideGroupId", this.state.errorResult)}>
                                    {(this.state.editFormData.roleName === 'Administrator' || this.state.editFormData.roleName === 'SalesRep') &&
                                        <ControlLabel>Default Order Guide*</ControlLabel>
                                    }
                                    {this.state.editFormData.roleName !== 'Administrator' && this.state.editFormData.roleName !== 'SalesRep' &&
                                        <ControlLabel>Order Guide*</ControlLabel>
                                    }
                                    <FormControl componentClass="select" value={this.state.editFormData.orderGuideGroupId || 'select'} name="orderGuideGroupId"
                                        onChange={this.onOrderGuideGroupSelected.bind(this)}
                                        inputRef={el => this.selectedOrderGuideGroupElem = el}
                                        placeholder="Select Order Guide"
                                    >
                                        <option key={'select'} value="">--Select--</option>
                                        {this.state.lookupOrderGuideGroups.map((ogg) =>
                                            <option key={ogg.orderGuideGroupId} value={ogg.orderGuideGroupId}>{ogg.orderGuideGroupName.length > 30 ? `${ogg.orderGuideGroupName.substring(0, 30)}...` : ogg.orderGuideGroupName}</option>
                                        )}
                                    </FormControl>
                                    <HelpBlock>{BsValidation.getFieldValidationText("orderGuideGroupId", this.state.errorResult)}</HelpBlock>
                                </FormGroup>
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col sm={12} style={{ textAlign: 'center' }}>
                            <button type="submit" className="ogcButton btn-std-size">Save</button>
                            {this.state.editState === EditState.Edit &&
                                <button type="button" className="ogcButton btn-std-size" onClick={this.onDeleteClicked.bind(this)} style={{ marginLeft: '8px' }}>Delete</button>
                            }
                            <button type="button" className="ogcButton ogcButton-brown btn-std-size" onClick={this.onCancelClicked.bind(this)} style={{ marginLeft: '8px' }}>Cancel</button>
                        </Col>
                    </Row>
                </form>
                <Prompt when={this.state.isDirty} message="Changes to this User will be lost. Continue?" />
            </Col>
        );
    }

    render(props) {
        if (this.state.errorCode !== 0) {

            if (this.state.errorCode === 401) {
                return (
                    <Redirect to="/login" />
                );
            } else {
                // todo
            }
        }

        return (
            <div>
                <PageHeader pageTitle="User Management"
                    pageHeaderRight={
                        <PageHeaderRight>
                            {!this.state.isEditing &&
                                <button className="pull-right ogcButton btn-std-size" type="button" onClick={this.addClicked}>Add</button>
                            }
                        </PageHeaderRight>
                    }
                />
                <div className="content-panel">
                    {this.state.isEditing && 
                        <div style={{ padding: '8px' }}>
                        <label style={{ fontSize: '18px' }}>{this.state.editState === EditState.Edit ? 'Edit User' : 'Add User'}</label>
                        {this.state.editFormData.id !== '' &&
                            <button type="button" className="ogcButton btn-std-size pull-right" onClick={this.sendPasswordReset}>Send Password Reset</button>
                        }
                        </div>
                    }
                    {
                        this.state.isEditing ? this.renderEditForm() : this.renderListGrid()
                    }

                    <ModalOKCancel
                        title="Delete User"
                        body={`Delete ${this.state.editFormData.userName}?`}
                        show={this.state.showDeleteModal}
                        onOK={this.onDeleteModalOK.bind(this)}
                        onCancel={this.onDeleteModalCancel.bind(this)}
                    />

                </div>
            </div>
        );
    }

}

export default Users;



// WEBPACK FOOTER //
// ./src/components/Admin/Users.js